import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { PictureAndTextSectionCms } from '~/cms/interfaces/homepage.cms.interface';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';

@Component({
  selector: 'app-cms-picture-and-text-section',
  templateUrl: './picture-and-text.component.html',
})
export class CmsPictureAndTextSectionComponent implements OnInit, OnDestroy {
  @Input() public section: PictureAndTextSectionCms;

  private readonly subscriptions = new Subscription();
  public readonly vtmnPlayVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;

  public isMobileDevice: boolean;

  constructor(private readonly matchMediaService: MatchMediaService) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public get isTextRightPosition(): boolean {
    return this.section.text_position === 'right';
  }

  public get isBlueVariant(): boolean {
    return this.section.variant === 'blue';
  }

  public get imageSrc() {
    let imageFormat = '';
    if (this.isMobileDevice) {
      if (this.section.image_mobile?.formats?.medium?.url) {
        imageFormat = this.section.image_mobile?.formats?.medium?.url;
      } else {
        imageFormat = this.section.image?.formats?.small?.url;
      }
    } else if (
      !this.isMobileDevice &&
      (this.section.text_position === 'left' ||
        this.section.text_position === 'right')
    ) {
      imageFormat = this.section.image?.formats?.medium?.url
        ? this.section.image?.formats?.medium?.url
        : this.section.image?.url;
    } else {
      imageFormat = this.section.image.url;
    }

    return imageFormat;
  }

  public get alt(): string {
    return this.isMobileDevice
      ? this.section?.image_mobile?.alternativeText
      : this.section?.image?.alternativeText;
  }

  public get hasLink(): boolean {
    return !!(this.section?.link_label && this.section?.link_url);
  }
}
